import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import useTheme from "../../hooks/useTheme";

// components
import Logo from "./Logo";
import Navbar from "./Navbar";

const Header = () => {
	const { pathname } = useLocation();
	const { theme } = useTheme();
	const [colorChange, setColorChange] = useState(false);

	const changeHeaderBgColor = () => {
		if (window.scrollY >= 80) {
			setColorChange(true);
		} else {
			setColorChange(false);
		}
	};

	window.addEventListener("scroll", changeHeaderBgColor);

	return (
		<div
			className={`min-h-32 ${
				pathname === "/about" ? "w-full sticky top-0" : ""
			} overflow-hidden hidden lg:flex items-center justify-between mb-5 ${
				colorChange
					? theme === "dark"
						? "bg-black text-white transition-all duration-500 "
						: "bg-white text-black transition-all duration-500 "
					: ""
			} z-10`}>
			<Logo />
			<Navbar />
		</div>
	);
};

export default Header;
